export default "__VITE_ASSET__CB7xy5dY__"